export default __webpack_public_path__ + "static/media/front_1.d2f80fd2.jpg";